import React, { useState, useEffect } from 'react';
import { Tabs } from '../../../app/components/Tabs';
import CardTemplates from '../../../app/components/CardTemplates';
import { usePageTitle } from '../../../contexts/PageTitleContext';


const TodoDo = () => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle('To Do');
    }, [setTitle]); 

  const [activeTab, setActiveTab] = useState('Hoje');

  const sequencesByStatus = {
    Hoje: [
      {
        title: 'DP - REGULARIZAÇÃO DE OMISSÃO DE DCTF WEB',
        subtitle: 'Ordens de Serviços',
        count: 1,
        pessoa: 'Rayana',
        data: '19/06/2025 14:38',
        status: 'Criado há 1 d',
        statusLabel: 'Hoje',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
      {
        title: 'DP - SIMULAÇÃO - FÉRIAS',
        subtitle: 'Ordens de Serviços',
        count: 5,
        pessoa: 'Natallia Marissa',
        data: '19/06/2025 17:54',
        status: 'Criado há 18 h',
        statusLabel: 'Hoje',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
      {
        title: 'CREDENCIAMENTO PREFEITURA',
        subtitle: 'Ordens de Serviços',
        count: 5,
        pessoa: 'Fabricio Pereira',
        data: '19/06/2025 18:00',
        status: 'Criado há 1 d',
        statusLabel: 'Hoje',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
      {
        title: 'Fiscal - EMISSÃO DE NOTA FISCAL',
        subtitle: 'Ordens de Serviços',
        count: 5,
        pessoa: 'Adriellen Neves',
        data: '19/06/2025 18:14',
        status: 'Criado há 18 h',
        statusLabel: 'Hoje',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
    ],
    'A Vencer': [
      {
        title: 'EMPREENDIMENTOS MASTER LTDA',
        subtitle: 'Certificados Digitais',
        count: 11,
        pessoa: 'Barbara Lima',
        data: '20/06/2025 00:00',
        status: 'Criado há 44 d',
        statusLabel: 'A Vencer',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
      {
        title: 'CONSULTORIA FINANCEIRA LTDA',
        subtitle: 'Ordens de Serviços',
        count: 15,
        pessoa: 'Felipe Santos',
        data: '25/06/2025 14:30',
        status: 'Criado há 10 d',
        statusLabel: 'A Vencer',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
    ],
    Vencidas: [
      {
        title: 'PAGAMENTO DE IMPOSTOS',
        subtitle: 'Ordens de Serviços',
        count: 0,
        pessoa: 'Carlos Ferreira',
        data: '17/06/2025 10:22',
        status: 'Criado há 3 d',
        statusLabel: 'Vencida',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
      {
        title: 'ALTERAÇÃO DE CADASTRO',
        subtitle: 'Ordens de Serviços',
        count: 0,
        pessoa: 'Luiza Mendes',
        data: '18/06/2025 09:14',
        status: 'Criado há 2 d',
        statusLabel: 'Vencida',
        avatar:
          'https://images.pexels.com/photos/32547348/pexels-photo-32547348.jpeg',
      },
    ],
  };

  const tabsOrder = ['Hoje', 'A Vencer', 'Vencidas'];

  return (
    <div>
      <div className="container mx-auto ">
        <div className="flex flex-col items-center mb-8">
          <div className="w-full flex flex-col items-center mb-8">
            <Tabs
              tabs={tabsOrder.map(name => ({ name, icon: null }))}
              tabsName={tabsOrder}
              align = 'left'
              activeTabName={activeTab}
              onTabClick={(tab) => {
                setActiveTab(tab);
              }}
            />
          </div>

          <div className="flex flex-col w-full gap-4 overflow-full">
            {sequencesByStatus[activeTab].map((item, index) => (
              <CardTemplates
                key={index}
                title={item.title}
                subtitle={item.subtitle}
                count={item.count}
                pessoa={item.pessoa}
                data={item.data}
                status={item.status}
                statusLabel={item.statusLabel}
                avatar={item.avatar}
                variant="secondary"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodoDo;